
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class Recruitment extends Vue {
  name = "Recruitment";

  get isZh(): boolean {
    return this.$i18n.locale === "zh";
  }
}
